import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
    LIFECYCLE_STATUS_MAP,
    HEALTH_STATUS,
    HEALTH_STATUS_MAP,
} from 'common/constants/lifecycle-and-health-mappings';
import { Indicator } from './indicator';

export function getCampaignIndicatorSpec({ status, health, showHealth }) {
    const statusSpec = LIFECYCLE_STATUS_MAP[status];
    const safeStatusSpec = statusSpec || {
        label: String(status || 'Unknown'),
        tone: 'neutral',
        variant: 'filled',
        Icon: undefined,
    };

    if (!showHealth || !health) return statusSpec;

    // const allowed = VALID_HEALTH_BY_LIFECYCLE[status] || [];
    // if (!allowed.includes(health)) return statusSpec;

    const base = HEALTH_STATUS_MAP[health];
    if (!base) return safeStatusSpec;

    return base;
}

export function CampaignIndicator({
    status,
    health,
    size = 'small',
    count,
    variant,
    showHealth = false,
    className,
    style,
    onClick,
    disabled = false,
}) {
    if (showHealth && health === HEALTH_STATUS.none) return null;

    const spec = useMemo(() => getCampaignIndicatorSpec({ status, health, showHealth }), [
        status,
        health,
        showHealth,
    ]);

    const iconSize = size === 'small' ? 'small' : 'medium';
    const IconEl = spec && spec.Icon ? <spec.Icon fontSize={iconSize} /> : undefined;

    const isClickable = Boolean(showHealth && health && typeof onClick === 'function');

    return (
        spec && (
            <Indicator
                label={spec.label}
                tone={spec.tone}
                variant={variant || spec.variant || 'filled'}
                size={size}
                count={count}
                IconEl={IconEl}
                className={className}
                style={style}
                clickable={isClickable}
                onClick={
                    isClickable
                        ? e => onClick(e, { entity: 'campaign', status, health })
                        : undefined
                }
                disabled={isClickable ? disabled : undefined}
                ariaLabel={spec.label}
            />
        )
    );
}

CampaignIndicator.propTypes = {
    status: PropTypes.oneOf([...Object.keys(LIFECYCLE_STATUS_MAP)]),
    health: PropTypes.oneOf([...Object.keys(HEALTH_STATUS_MAP)]),
    size: PropTypes.oneOf(['small', 'medium']),
    count: PropTypes.number,
    variant: PropTypes.oneOf(['filled', 'outlined']),
    showHealth: PropTypes.bool,
    className: PropTypes.string,
    style: PropTypes.object,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
};

export default CampaignIndicator;
